import { api } from "./axios";

export async function sendResetCode(data) {
    let res = await api.post("user/auth/send-ResetCode", data);
    if (res) return res.data.data;
    else return false;
}

export async function changePassword(data) {
    let res = await api.post("user/auth/change-password", data);
    if (res) return res.data.data;
    else return false;
}

